import BaseComponent from '../../../../common/js/BaseComponent';

export default class Header extends BaseComponent {
    init(): any {
        this.onLoad();
        this.onScroll();
        this.mobileNavListener();
    }

    onLoad() {
        if (this.view.offsetTop > 200) {
            this.reduceHeader();
        }
    }

    onScroll() {
        window.addEventListener('scroll', () => {
            if (window.innerWidth > 992) {
                if (window.scrollY > 200) {
                    this.reduceHeader();
                } else {
                    this.increaseHeader();
                }
            }
        });
    }

    reduceHeader() {
        this.view.classList.add('is-reduce');
    }

    increaseHeader() {
        this.view.classList.remove('is-reduce');
    }

    mobileNavListener() {
        this.view.querySelector('#mobileNavbar')?.addEventListener('show.bs.collapse', () => {
            this.onMobileNavOpen();
        });
        this.view.querySelector('#mobileNavbar')?.addEventListener('hide.bs.collapse', () => {
            this.onMobileNavClose();
        });
    }

    onMobileNavOpen() {
        document.querySelector('body')?.classList.add('overflow-hidden');
    }

    onMobileNavClose() {
        document.querySelector('body')?.classList.remove('overflow-hidden');
    }
}
